document.querySelectorAll('[data-product-video-player]').forEach((player) => {
  const video = player.querySelector('video');
  const overlay = player.querySelector('[data-product-video-overlay]');

  if (!video || !overlay) {
    return;
  }

  // Начальное состояние
  player.classList.add('is-paused');
  video.controls = false;
  video.setAttribute('controlsList', 'nodownload');
  video.setAttribute('disablePictureInPicture', '');
  video.setAttribute('playsinline', '');

  video.muted = true;

  const playVideo = async () => {
    try {
      video.muted = false;
      video.volume = 1;

      await video.play();
    } catch (error) {
      console.error('Unable to play video:', error);
    }
  };

  const pauseVideo = () => {
    video.pause();
  };

  overlay.addEventListener('click', () => {
    if (video.paused || video.ended) {
      playVideo();
    } else {
      pauseVideo();
    }
  });

  player.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  video.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  overlay.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  video.addEventListener('play', () => {
    player.classList.add('is-playing');
    player.classList.remove('is-paused');

    overlay.setAttribute('aria-label', 'Pause video');
  });

  video.addEventListener('pause', () => {
    player.classList.remove('is-playing');
    player.classList.add('is-paused');

    overlay.setAttribute('aria-label', 'Play video');
  });

  video.addEventListener('ended', () => {
    player.classList.remove('is-playing');
    player.classList.add('is-paused');

    overlay.setAttribute('aria-label', 'Play video');
  });
});